<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    right1Data: {
      type: Object,
      default: () => {
      },
    },
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      chart.init(props.right1Data);
    });
    return {
      myEcharts,
    };
  },
};

class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init(right1Data) {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

    const datas = [
      {
        name: '农副产品加工',
        value: 40
      }, {
        name: '纺织服装制鞋',
        value: 48
      }, {
        name: '电子电器',
        value: 4
      }, {
        name: '其他',
        value: 3
      }
    ]
    this.state.chart.setOption({
      color: ['#F56463', '#00C6FF', '#F09615', '#0079E6'],
      legend: {
        itemHeight: 14,
        itemWidth: 14,
        itemGap: 30,
        icon: 'rect',
        orient: 'vertical',
        top: 'center',
        right: "10%",
        textStyle: {
          align: 'left',
          color: '#',
          verticalAlign: 'middle',
          rich: {
            name: {
              width: 200,
              fontSize: 30
            },
            value: {
              width: 100,
              align: 'right',
              fontFamily: 'Medium',
              fontSize: 30
            },
            rate: {
              width: 10,
              align: 'right',
              fontSize: 30
            }
          }
        },
        data: datas,
        formatter: (name) => {
          if (datas.length) {
            const item = datas.filter((item) => item.name === name)[0]
            return `{name|${name}}{value| ${item.value}} {rate| 亿}`
          }
        }
      },
      tooltip: {
        trigger: 'item',
        formatter: '{d}%',

      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['50%', '70%'],
          center: ['26%', '50%'],
          roseType: 'radius',
          label: {
            formatter: '{d}%',
            fontSize: 24,
            color: "#fff"
          },
          labelLine: {
            length: 1,
            length2: 20,
          },
          data: datas
        }
      ]
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
